import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { useParams } from 'react-router-dom';
import HrbTranslate from '../../../components/language/HrbTranslate';
import Lang from '../../../components/language/services/Lang';
import VerticalNameValue from '../../../components/library/layout/VerticalNameValue';
import ClientActions from '../../../store/clientRedux';

const ClientSecurityInformation = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    const [questionValue, setQuestionValue] = useState(null);

    const loading = useSelector(state => state.client.loadingSecurityInfo)
    const securityInfo = useSelector(state => state.client.clientSecurityInfo, shallowEqual)
    const lang = useSelector(state => state.layout.lang);

    useEffect(() => {
        if (id) {
            dispatch(ClientActions.getSecurityInfo(id));
        }
    }, [id])

    useEffect(() => {
        if (securityInfo.securityQuestion) {
            setQuestionValue(Lang.getCurrentValue("Account.SecurityQuestions." + securityInfo.securityQuestion))
        } else {
            setQuestionValue(null);
        }
    }, [securityInfo.securityQuestion, lang]);

    return (
        <Fragment>
            <div className='columns'>
                <div className='column is-1' />
                <div className='column is-10'>
                    <h4 className='h4-vert-spacing'><HrbTranslate text='Account.Headers.SecurityInfo' /></h4>
                </div>
                <div className='column is-1' />
            </div>
            <div className='columns'>
                <div className='column is-1' />
                <div className='column is-4'>
                    <VerticalNameValue
                        textKey='Account.Labels.SecurityQuestion'
                        loading={loading}
                        value={questionValue}
                    />
                </div>
                <div className='column is-4'>
                    <VerticalNameValue
                        textKey='Account.Labels.Answer'
                        loading={loading}
                        value={securityInfo.securityAnswer}
                    />
                </div>
                <div className='column is-2'>
                    <VerticalNameValue
                        textKey='Account.Labels.Hint'
                        loading={loading}
                        value={securityInfo.securityHint}
                    />
                </div>
                <div className='column is-1' />
            </div>
        </Fragment>
    );
}

ClientSecurityInformation.propTypes = {
    clientId: PropTypes.number
}

ClientSecurityInformation.whyDidYouRender = false;

export default ClientSecurityInformation